import { Col, Row, Container, Image } from 'react-bootstrap';
import Main from '../components/Layout/Main';
import Sidebar from '../components/Layout/Sidebar';
import LeftHero from '../components/Hero/LeftHero';
import PageHeader from '../components/PageHeader';
import OpeningHours from '../components/Sidebar/OpeningHours';
import OpenJobsDisclaimer from '../components/Jobs/JobDisclaimer';
import Neukauf from '../components/Sidebar/Neukauf';
import Fullwidth from '../components/Layout/Fullwidth';

function Home() {
    const yearsOfExperience = (new Date().getFullYear()) - 1880;
  return (
    <div>
        <PageHeader title="Heinrich Heiden GmbH & Co. KG" subtitle="Servicepartner der MAN Truck and Bus Deutschland GmbH" />
        <Row className='page-main'>
            <Fullwidth>
                <LeftHero
                    title={yearsOfExperience + " Jahre Erfahrung!"}
                    teaser="Mit Herz und Fortschritt - immer für Sie da! Wir reparieren und warten <b><u>alle Fabrikate</u></b> - stets zu Ihrer Zufriedenheit!"
                    buttonLink="/leistungen" buttonText="Unsere Leistungen"
                    image="/man_alle_modelle.png" />
                <Row>
                    <Col className='teaser-1' xs={12} md={4}>
                        <OpenJobsDisclaimer />
                    </Col>
                    <Col className='teaser-2' xs={12} md={4}>
                        <Neukauf />
                    </Col>
                    <Col className='teaser-3 d-flex' xs={12} md={4}>
                        <OpeningHours />
                    </Col>
                </Row>
            </Fullwidth>
        </Row>
    </div>
  );
}

export default Home;